import React from 'react';
import { MenuProps } from 'antd';
import { Trans } from 'react-i18next';
import { ColumnsType } from 'common/components/antd/Table/Table';
import { Tag } from 'common/components/antd/Tag/Tag';
import TableActionColumnDropdown from 'common/components/TableActionColumnDropdown/TableActionColumnDropdown';
import { ENV_COUNTERPARTY_GUID } from 'common/constants/env.constants';
import { IS_ADMIN_FE } from 'common/constants/general-access-role.constants';
import { alphabeticSortFn } from 'common/utils/sort.utils';
import {
  SStatusCell
} from './employees.page.style';
import { EEmployeesColumnKey } from './enums/employees.enum';
import { TEmployeesTableRecord } from './types/employees.types';

export const getColumns = ({
  selectedCounterparty,
  menuItems,
  onItemActionClick,
}: {
  selectedCounterparty?: string;
  menuItems?: MenuProps['items'];
  onItemActionClick?: any;
} = {}): ColumnsType<TEmployeesTableRecord> => [
    {
      title: <Trans i18nKey='usrRoleMng.employees.table.column.user' />,
      width: 221,
      key: EEmployeesColumnKey.User,
      dataIndex: EEmployeesColumnKey.User,
      searchable: true,
      sorter: alphabeticSortFn(EEmployeesColumnKey.User),
      render: (text) => ( <b>{text}</b> ),
    },
    {
      title: <Trans i18nKey='usrRoleMng.employees.table.column.role' />,
      width: 185,
      key: EEmployeesColumnKey.Role,
      dataIndex: EEmployeesColumnKey.Role,
      searchable: true,
    },
    {
      title: <Trans i18nKey='usrRoleMng.employees.table.column.email' />,
      width: 238,
      key: EEmployeesColumnKey.Email,
      dataIndex: EEmployeesColumnKey.Email,
      searchable: true,
      render: (text) => <b>{text}</b>,
    },
    {
      title: <Trans i18nKey='usrRoleMng.employees.table.column.phone' />,
      width: 190,
      key: EEmployeesColumnKey.Phone,
      dataIndex: EEmployeesColumnKey.Phone,
      searchable: true,
    },
    {
      title: <Trans i18nKey='usrRoleMng.employees.table.column.counterparty' />,
      width: 193,
      key: EEmployeesColumnKey.Counterparty,
      dataIndex: EEmployeesColumnKey.Counterparty,
      searchable: true,
    },
    {
      title: <Trans i18nKey='usrRoleMng.employees.table.column.branch' />,
      width: 145,
      key: EEmployeesColumnKey.Branch,
      dataIndex: EEmployeesColumnKey.Branch,
      searchable: true,
    },
    {
      title: <Trans i18nKey='usrRoleMng.employees.table.column.status' />,
      width: 130,
      key: EEmployeesColumnKey.Status,
      dataIndex: EEmployeesColumnKey.Status,
      searchable: true,
      render: (status: number) => (
        <SStatusCell>
          <Tag color={[undefined, 'green', 'volcano'][status]}>
            {['Closed', 'Active', 'Blocked'][status]}
          </Tag>
        </SStatusCell>
      ),
    },
    ...(!IS_ADMIN_FE || (IS_ADMIN_FE && selectedCounterparty === ENV_COUNTERPARTY_GUID)
      ? [
          {
            title: '',
            width: 20,
            dataIndex: EEmployeesColumnKey.Menu,
            searchable: false,
            render: (status: number, record: any) => (
              <TableActionColumnDropdown
                record={record}
                onClickItemAction={onItemActionClick}
                menuItems={menuItems}
              />
            ),
          }
        ]
      : []),
];
